export default "__VITE_ASSET__q8Y0igPZ__"